(function() {
	'use strict';

	angular
		.module('dat.shared-components.common')
		.directive('datModalDialog', datModalDialog)
		.controller('ModalDialogCtrl', ModalDialogCtrl);

	function datModalDialog() {
		return {
			restrict: 'EA',
			replace: true,
			transclude: true,
			scope: {
				show: '=datShow',
				title: '=datTitle',
				showCloseLink: '=datShowCloseLink',
				hideHeader: '@datHideHeader',
				cssClass: '@datCssClass',
				clickOutsideClosesModal: '@datClickOutsideClosesModal',
				closeConfirmFn: '&datCloseConfirm',
				closeConfirmButtonText: '@datCloseConfirmButtonText'
			},
			templateUrl: '/app/shared-components/common/modal-dialog.html',
			controller: 'ModalDialogCtrl',
			controllerAs: 'ctrl',
			link: modalDialogLinkFn
		};
	}

	ModalDialogCtrl.$inject = ['$scope', '$element', 'eventNameService', '$timeout', '$document'];
	var $document;

	function ModalDialogCtrl($scope, $element, eventNameService, $timeout, _$document_) {
		var self = this;
		$document = _$document_;

		self.m = {
			title: $scope.title,
			showCloseLink: $scope.showCloseLink,
			isShown: $scope.show,
			hideHeader: ($scope.hideHeader || false),
			cssClass: $scope.cssClass || '',
			clickOutsideClosesModal: $scope.clickOutsideClosesModal || true,
			closeConfirmFn: $scope.closeConfirmFn || null,
			closeConfirmVisible: false,
			closeConfirmButtonText: $scope.closeConfirmButtonText || 'close',
			closeConfirmMessage: ''
		};

		self.initiateCloseModal = initiateCloseModal;
		self.closeModal = closeModal;
		self.outsideModalClicked = outsideModalClicked;
		self.cancelClose = cancelClose;

		activate();

		////////////////////

		function activate() {
			moveElementToBody();
		}

		function moveElementToBody() {
			if ($element.appendTo) {
				$timeout(function() {
					$element.appendTo('body');
				});
			}
		}

		$scope.$watch('show', function(newValue) {
			self.m.isShown = newValue;
			reset();
			$timeout(function() {
				if (self.m.isShown === true) {
					$element = $($element);
					var firstTabbable = $element.find(':tabbable')[0];
					if (firstTabbable) {
						firstTabbable.focus();
						if (firstTabbable.select) {
							firstTabbable.select();
						}
					} else {
						$element[0].focus();
					}
				}
			});
		});

		$scope.$watch('title', function(newValue) {
			self.m.title = newValue;
		});

		$scope.$watch('cssClass', function(newValue) {
			self.m.cssClass = newValue;
		});

		function outsideModalClicked() {
			if (self.m.clickOutsideClosesModal === true) {
				closeModal();

				return;
			}
		}

		function initiateCloseModal() {
			var close = true;
			if (self.m.closeConfirmFn) {
				var closeConfirmInnerFn = self.m.closeConfirmFn();
				if (closeConfirmInnerFn) {
					self.m.closeConfirmMessage = closeConfirmInnerFn();
					if (self.m.closeConfirmMessage) {
						close = false;
						self.m.closeConfirmVisible = true;
					}
				}
			}
			if (close) {
				closeModal();
			}
		}

		function closeModal() {
			self.m.isShown = $scope.show = false;
			$scope.$root.$broadcast(eventNameService.modalDialog.closed);
		}

		function cancelClose() {
			self.m.closeConfirmVisible = false;
		}

		function reset() {
			self.m.closeConfirmVisible = false;
			self.m.closeConfirmMessage = '';
		}
	}

	function modalDialogLinkFn(scope, _element) {
		var element = $(_element);
		registerElementEventHandlers();

		function registerElementEventHandlers() {
			if ($document) {
				$document.on('focusin', trapFocus); // required for IE
				$document.on('focus', trapFocus);
			}
			element.on('keydown', keyDownHandler);
			element.on('$destroy', destroyCleanup);
		}

		function keyDownHandler(e) {
			var tabbable = element.find(':tabbable'),
				firstTabbable = tabbable[0],
				lastTabbable = tabbable[tabbable.length - 1];

			if (e.which === 9) {
				e.originalEvent.isAlreadyHandled = true;
				if (e.target === lastTabbable || (e.target === firstTabbable && e.shiftKey)) {
					e.preventDefault();
					firstTabbable.focus();
					if (firstTabbable.select) {
						firstTabbable.select();
					}
				}
			}
		}

		function trapFocus(e) {
			if (!$(element).is(':visible')) {
				return;
			}
			if (element[0].contains && !element[0].contains(e.target)) {
				e.stopPropagation();
				element.focus();
			}
		}

		function destroyCleanup() {
			if ($document) {
				$document.on('focusin', trapFocus);
				$document.off('focus', trapFocus);
				$document = null;
			}
			element.off('keydown', keyDownHandler);
		}
	}
})();
